import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import SignaturePad from "signature_pad";

@Injectable({
  providedIn: 'root'
})
export class SignaturePadService {

  private subject = new Subject<SignaturePad>();

  currentSignaturePad = this.subject.asObservable();

  constructor() { }

  update(signaturePad: SignaturePad) {
    this.subject.next(signaturePad);
  }
}
